import { JSX } from 'react';
import { Box, Typography } from '@mui/material';
import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';

interface Props {
  show: boolean;
}

export default function AIProvenanceHint({ show }: Props): JSX.Element | null {
  if (!show) {
    return null;
  }
  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        bgcolor: 'primary.lighter',
        borderRadius: '10px',
        px: 1.75,
        py: 1.25,
        mb: 2,
      }}
    >
      <AutoAwesomeIcon sx={{ fontSize: 16, color: 'primary.main' }} />
      <Typography
        sx={{
          fontSize: 12,
          fontWeight: 500,
          color: 'primary.main',
          lineHeight: 1.4,
        }}
      >
        We filled this from your documents — please confirm
      </Typography>
    </Box>
  );
}
